import { useActiveLayerContext } from '@/context/__project__/ActiveLayerContext'
import { useBuilderActionContextV2 } from '@/context/__project__/BuilderActionContextV2'
import { useCompBackgroundColor, useCompContext } from '@/context/__project__/CompContext'

import { CompPromptWrapperCore } from '../core/prompt/wrapper'

function CompPromptWrapper() {
  // infos
  const compContext = useCompContext()
  const { currentParentBg } = useCompBackgroundColor()
  const { activeLayer } = useActiveLayerContext()
  const infosProps = { ...compContext, activeLayer, currentParentBg }

  // action
  const actionContext = useBuilderActionContextV2()

  // tableData
  // const { dbClient, language, userSpecific } = useDbClientContext()
  // const tableId = compContext.settings?.[ComponentSettingKey.PromptDataSource]
  // const table = dbClient?.GetTable(tableId as string)

  // if (!table || !dbClient) {
  //   return <div className='flex justify-center items-center py-8'>Loading...</div>
  // }

  return <CompPromptWrapperCore infos={infosProps} action={actionContext} />
}

export default CompPromptWrapper
